import React from "react";


function Timing() {
  return (
    <div>
     <div className="row banner" style={{ display:'flex',alignItems:'center',justifyContent:'center',background:'orange', backgroundSize: 'cover', backgroundPosition: 'center',height:'400px' }}>
      <img src="./images/maruthi.png" alt="image" style={{width:'20%'}} />
      </div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
            <div className="col-md-12" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <p className="darsan-time"></p>
                <p className="darsan-time">ഞായർ മുതൽ വെള്ളിവരെ രാവിലെ 6 മുതൽ 9 വരെ </p>
                <p className="darsan-time">വൈകിട്ട് 5.30 മുതൽ 7 മണി വരെ</p>
                <p className="darsan-time">ശനിയാഴ്ച രാവിലെ 5.30 മുതൽ 10 മണി വരെ</p>
                <p className="darsan-time">വൈകിട്ട് 5.30 മുതൽ 7 മണി വരെ</p>
            
           </div> 
            {/* <div class="col-md-5" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}>
                
            </div> */}
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;